import DispatcherEvent from "./DispatcherEvent";
import {setReadCount} from "../../dashboard/actions";
import { Auth } from 'aws-amplify';


export default class InstaSignaler {
    constructor() {
        this.events = {};
        this.wsUri = "wss://af2q6bpzbk.execute-api.ap-southeast-1.amazonaws.com/dev";
        // this.wsUri = "wss://8a7v2yzkva.execute-api.ap-southeast-1.amazonaws.com/dev";
        this.webSocket = null;
        this.isConnected = false;
        this.subscribers = [];
        this.reConnect = false;
        this.uid = null;
        this.isBusy = false;
    }

    dispatch(eventName, data) {
        const event = this.events[eventName];
        if (event) {
            event.fire(data);
        }
    }

    on(eventName, callback) {
        let event = this.events[eventName];
        if (!event) {
            event = new DispatcherEvent(eventName);
            this.events[eventName] = event;
        }
        event.registerCallback(callback);
    }

    off(eventName, callback) {
        const event = this.events[eventName];
        if (event && event.callbacks.indexOf(callback) > -1) {
            event.unregisterCallback(callback);
            if (event.callbacks.length === 0) {
                delete this.events[eventName];
            }
        }
    }

    subscribeOnlineStatus = (userSub, myId) => {
        if(this.isConnected){
            if (userSub) {
                // console.log('Subscribed for', userSub);
                try{
                    if(this.subscribers.indexOf(userSub) < 0){
                        this.subscribers.push(userSub);
                    }
                    // console.log('Trying to send messagge to ', userSub);
                    this.webSocket.send(`{"action" : "isOnline" , "message" : "subscribe", "selfId" : "${myId}", "uid" : "${userSub}"}`);
                }catch(error) {
                    console.log('Error connecting socket', error);
                }
            }
        }else {
            // try after 5 seconds
            setTimeout(()=> {
                this.subscribeOnlineStatus(userSub, myId);
            }, 5000);
        }
    }

    init = (uid, reConnect = false) => {
        // console.log('uid to ', uid);
        this.webSocket = new WebSocket(this.wsUri+'/?userId=' + uid);
        this.webSocket.onopen = this.onOpen;
        this.webSocket.onclose = this.onClose;
		this.webSocket.onmessage = this.onMessage;
        this.webSocket.onerror = this.onError;
        window.webSock = this.webSocket;

        this.reConnect = reConnect;
        this.uid = uid;
    }

    onOpen = (event) => {
        console.log("Websocket Open", event);
        this.isConnected = true;
        this.dispatch('connected', event.data);

        if(this.reConnect && this.uid) {
            this.subscribers.forEach((subscriber) => {
                this.subscribeOnlineStatus(subscriber, this.uid);
            });
            this.reConnect = false;
        }
    }

    onClose = (event) => {
        this.isConnected = false;
        console.log("Websocket Closed", event);
        // this.uid = null;
        this.dispatch('off-subscribe', event.data);
        this.dispatch('closed-ws', event.data);
        setTimeout( ()=> {
            this.init(this.uid, true);
        }, 300);
    }

    onMessage = (event) => {
        // console.log("Websocket onMessage", event.data);
        const data = JSON.parse(event.data);
        if(data.command === 'PRESENCE') {
            this.dispatch(data.uid, data.status);
        }
        if(data.command === 'CALLREQUEST') {
            // if(is)
            this.dispatch('oncall-receiver', data.body);
        }

        if(data.command === 'CALLDECLAINED') {
            this.dispatch('call-declained', {});
        }

        if(data.command === 'CALLACCEPTED') {
            this.dispatch('call-accepted', {selfId: data.body.remoteId, remoteId: data.body.senderId, publishVideo: true});
        }
        if(data.command === 'ENDCALL') {
            this.dispatch('oncall-ended', {});
        }
        if (data.command === 'INDCHAT') {
            let {store} = window;
            if (store.getState().dashboard.selectedUser !== data.body.createdBy) {
                store.dispatch(setReadCount(data.body.createdBy));
            } else {
                this.dispatch('recive-ind-chat', data.body);                
            }
        }
        if(data.command === 'GLOBALSIGNOUT') {
            // console.log("logout =============");
            Auth.signOut({ global: true });
            // window.location.href = '/';
            window.location.reload();
            // this.dispatch('global-signout', {});

            // this.props.userHasAuthenticated(false, null);
            // this.props.history.push("/");


        }
    }

    setBusy = (status) => {
        this.isBusy = status;
    }

    getBusyStatus = () => {
        return this.isBusy;
    }
    sendScreenShareRequest = (selfName, toId) => {
        if(this.isConnected) {
            let message = {
                action: 'onMessage',
                message: 'REQUEST_SCREENSHARE',
                uid: toId,
                data: {
                    senderName: selfName,
                }
            }
            //this.webSocket.send(`{"action" : "onMessage" , "message" : "callrequest", "selfId" : "${selfId}", "name" : "${userName}", "uid" : "${userId}"}`);
            this.webSocket.send(JSON.stringify(message));
            // this.dispatch('oncall-ended', {});
        }
    }
    sendEndCallRequest = (toId) => {
        if(this.isConnected) {
            let message = {
                action: 'onMessage',
                message: 'ENDCALL',
                uid: toId,
                data: {

                }
            }
            //this.webSocket.send(`{"action" : "onMessage" , "message" : "callrequest", "selfId" : "${selfId}", "name" : "${userName}", "uid" : "${userId}"}`);
            this.webSocket.send(JSON.stringify(message));
            this.dispatch('oncall-ended', {});
        }
    }
    sendCallRequest = (selfId, userId, name, remoteUserName) => {
        // console.log('Busy Status', this.isBusy);
        if(this.isConnected && !this.isBusy) {
            let message = {
                action: 'onMessage',
                message: 'CALLREQUEST',
                uid: userId,
                data: {
                    senderId: selfId,
                    name: name,
                    remoteUserName: remoteUserName,
                }
            }
            //this.webSocket.send(`{"action" : "onMessage" , "message" : "callrequest", "selfId" : "${selfId}", "name" : "${userName}", "uid" : "${userId}"}`);
            this.webSocket.send(JSON.stringify(message));
            this.dispatch('oncall-sender', message);
            return 1; //Request Sent
        }else if (this.isBusy) {
            return 2; //User Busy
        }else {
            return 3; //User Not Connected
        }
    }

    sendDeclainRequest = (selfId, userId) => {
        if(this.isConnected) {
            let message = {
                action: 'onMessage',
                message: 'CALLDECLAINED',
                uid: userId,
                data: {
                    senderId: selfId,
                }
            }
            this.webSocket.send(JSON.stringify(message));
            this.dispatch('call-declained', message);
        }
    }

    callAccepted = (selfId, remoteId) => {
        if(this.isConnected) {
            let message = {
                action: 'onMessage',
                message: 'CALLACCEPTED',
                uid: remoteId,
                data: {
                    senderId: selfId,
                    remoteId: remoteId
                }
            }
            this.webSocket.send(JSON.stringify(message));
            this.dispatch('call-accepted', {selfId: selfId, remoteId: remoteId, publishVideo: false});
        }
    }

    sendIndChat = (data, userId) => {
        if(this.isConnected) {
            let message = {
                action: 'onMessage',
                message: 'INDCHAT',
                uid: userId,
                data: data
            }
            this.webSocket.send(JSON.stringify(message));
            this.dispatch('recive-ind-chat', data);
        }
    }

    globalSignout = () => {
        if(this.isConnected) {
            let message = {
                action: 'onMessage',
                message: 'GLOBALSIGNOUT',
                uid: this.uid,
                data: {}
            }
            this.webSocket.send(JSON.stringify(message));
            this.dispatch('global-signout', {});
        }
    }

    onError = (event) => {
        console.log("Websocket Error", event)
    }
}